/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var QueueTask;
(function (QueueTask) {
    let status;
    (function (status) {
        status["WAITING"] = "waiting";
        status["ACTIVE"] = "active";
        status["STALLED"] = "stalled";
        status["COMPLETED"] = "completed";
        status["FAILED"] = "failed";
    })(status = QueueTask.status || (QueueTask.status = {}));
    let queueName;
    (function (queueName) {
        queueName["CONTACT_CSV"] = "contact-csv";
        queueName["CONTACT_SEARCH"] = "contact-search";
        queueName["PERSON_INGESTION"] = "person-ingestion";
        queueName["CONTACT_EMAIL_VALIDATION"] = "contact-email-validation";
        queueName["CHAT_NOTIFICATION"] = "chat-notification";
        queueName["JOB_BOARD_DATA_REQUESTS"] = "job-board-data-requests";
        queueName["CONTACT_SEARCH_SYNC"] = "contact-search-sync";
        queueName["JOB_BOARD_DATA_FORMATTING"] = "job-board-data-formatting";
        queueName["CONTACT_INGESTION"] = "contact-ingestion";
        queueName["APPLICATION_INGESTION"] = "application-ingestion";
        queueName["ROLE_INGESTION"] = "role-ingestion";
        queueName["JOB_BOARD_METADATA_GENERATION"] = "job-board.metadata.generation";
        queueName["JOB_BOARD_MAP_LOCATION"] = "job-board.map.location";
        queueName["JOB_BOARD_LOGO_ENRICHMENT"] = "job-board.logo.enrichment";
        queueName["NOTIFICATION_EVENTS"] = "notification-events";
        queueName["SEQUENCE_STEPS"] = "sequence-steps";
        queueName["WEBHOOK_PROCESSING"] = "webhook-processing";
        queueName["SEARCH_SESSION_SOURCING"] = "search-session-sourcing";
    })(queueName = QueueTask.queueName || (QueueTask.queueName = {}));
    let jobName;
    (function (jobName) {
        jobName["CONTACT_CSV_IMPORT_CONTACTS"] = "contact-csv.import-contacts";
        jobName["FORMAT_DATA_DESCRIPTION"] = "format_data_description";
        jobName["GENERATE_JOB_METADATA"] = "generate_job_metadata";
        jobName["MAP_JOB_LOCATION"] = "map_job_location";
        jobName["ENRICH_JOB_LOGO"] = "enrich_job_logo";
        jobName["SEQUENCE_STEPS_PROCESS_STEP"] = "sequence-steps.process-step";
        jobName["PROCESS_WEBHOOK"] = "process-webhook";
    })(jobName = QueueTask.jobName || (QueueTask.jobName = {}));
})(QueueTask || (QueueTask = {}));
